import React from "react";

import { Grid } from "@mui/material";
import { ColorsColumn } from "@src/components/ColorAndStyle/sections/components/ColorsColumn";

import { useColorConfiguration } from "../../hooks/use-color-configuration";
import { BaseColorWrapperProps } from "../../types";
import {
  getMessageBoxColorFields,
  getMessageBoxTextColorFields,
} from "../../utils/fields";

import { ColorThemeHeader } from "./ColorThemeHeader";

export const MessageBoxColorsWrapper = ({
  widgetType,
  colorTheme,
  onColorChange,
  offer,
  widget,
  quantityButtonVariant,
}: BaseColorWrapperProps) => {
  const { getPrimaryColor, colorFieldsConfig } = useColorConfiguration({
    widgetType,
    colorTheme,
    widget,
    quantityButtonVariant,
    offer,
  });

  const widgetColorSection = getMessageBoxColorFields(colorFieldsConfig);
  const textColorSection = getMessageBoxTextColorFields(colorFieldsConfig);

  return (
    <Grid item container spacing={3}>
      <ColorThemeHeader
        primaryColor={getPrimaryColor()}
        onColorChange={onColorChange}
      />
      <ColorsColumn
        widgetType={widgetType}
        colorFields={widgetColorSection.colorFields}
        sectionTitle={widgetColorSection.sectionTitle}
        onColorChange={onColorChange}
        xs={4}
      />
      <ColorsColumn
        colorFields={textColorSection.colorFields}
        onColorChange={onColorChange}
        sectionTitle={"Text"}
        widgetType={widgetType}
        xs={4}
      />
    </Grid>
  );
};
